// extracted by mini-css-extract-plugin
export default {"zoomModal":"r2-z","image":"s2-z","button":"t2-z","isOverlayShown":"u2-z"};